export default __webpack_public_path__ + "static/media/401.fb3e8f15.png";